import type {ReactElement} from 'react';
import {Text, TextSize} from '@Components/text';
import {SocialAccountConnectionInstructions} from '@Components/social-media-wizard/components/social-account-connection';
import {getSocialPlatformName} from '@Libraries/social-media-platform.library';
import type {SocialPlatformConnectionDropdownProps} from './social-platform-connection-dropdown.types';
import styles from './social-platform-connection-dropdown.module.scss';

export function SocialPlatformConnectionDropdown({platform, hasFullWidthActions, onCancel, onAccountConnected}: SocialPlatformConnectionDropdownProps): ReactElement {
  return (
    <div className={styles.connectionDropdown}>
      <Text
        className="spacing-m-b-2 ct-neutral-primary"
        size={TextSize.MD}
        bold
        val={window.i18next.t('pmwjs_publish_to_x', {socialPlatform: getSocialPlatformName(platform)})}
      />
      <SocialAccountConnectionInstructions accountType={platform} onCancel={onCancel} isFullWidth={hasFullWidthActions} onAccountConnected={onAccountConnected} />
    </div>
  );
}
